import { entity, persistence } from 'simpler-state';
import { AppConfig } from '../config/config';

const contentsKey = `${AppConfig.storagePrefix}_contents`;

export const pageContents = entity<any>(null, [persistence(contentsKey, {})]);
